import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function GuyChiricoPage() {
  return <AttorneyBioTemplate attorney={attorneys['attorney-executive-advisor-at-morgan-legal-group']} />;
}
